import React, { useState, useRef, useEffect } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import { useContextApi } from "../../../context/ContextApi";
import Table from "../../../constants/Table";
import { toPrimaryQuantity, toSecondaryQuantity } from "@heartinz/finance";
import uRLs from "../../../utils/baseUtils";
import StockOut from "../stockbatch/StockOut";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { TrashIcon } from "../../../constants/Icons";

const ViewAvailable = ({ data, onClose, onStockUpdate }) => {
  console.log("Received stock data in ViewAvailable:", data);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);
  const { getColor } = useContextApi();
  const [isStockData, setStockData] = useState(data);
  const [isDeleteBtnLoading, setDeleteBtnLoading] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isSelectedItem, setSelectedItem] = useState({});
  const [isSelectedIndex, setSelectedIndex] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const inputRef = useRef(null);
  const remarksRef = useRef(null);

  const [selectedUnitType, setSelectedUnitType] = useState("primary");

  const openDeleteModal = (item, index) => {
    setSelectedItem(item);
    setSelectedIndex(index);
    setDeleteModalOpen(true);
    setSelectedUnitType("primary");
    setQuantity("");
    setDescription("");
    setErrorMessage("");
  };

    const closeCurrentModal = () => {
        setDeleteModalOpen(false);
        setSelectedItem({});
        setSelectedIndex(null);
    };
    const primaryQuanity=(quanity,unitData)=>{
        const qty=toPrimaryQuantity(quanity, unitData);
        return qty?.primaryQty;
      }


        const stockValue = data?.isSecondaryUnit
    ? secondaryQuanity(data?.stockLeft, data?.unitConfig)
    : data?.stockLeft;
    // const handleQuantityChange = (e) => {
    //     const value = e.target.value.replace(/\D/g, "");
    //     const parsedValue = value ? parseInt(value, 10) : "";
    //     if (parsedValue > isSelectedItem.stockLeft) {
    //         setQuantity(isSelectedItem.stockLeft);
    //         setErrorMessage(`Quantity cannot exceed available stock (${isSelectedItem.stockLeft}).`);
    //     } else if (parsedValue < 1 && value !== "") {
    //         setQuantity("");
    //         setErrorMessage("Quantity must be at least 1.");
    //     } else {
    //         setQuantity(parsedValue);
    //         setErrorMessage(null);
    //     }
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
      
        if (name === "inputValue") {
      
          if (value === "") {
            setQuantity("");
            return;
          }
      
          const quantityRegex =
            uRLs.UNIT === "true" && data?.unitConfig
              ? /^\d*\.?\d{0,3}$/ // decimal allowed
              : /^\d+$/; // integer only
      
          if (!quantityRegex.test(value)) return;
      
          const parsedValue =
            uRLs.UNIT === "true" && data?.unitConfig
              ? parseFloat(value)
              : parseInt(value, 10);
      
          if (parsedValue > stockValue) {
            setQuantity(String(stockValue));
      
          } else if (parsedValue < 1) {
            setQuantity("1");
      
          } else {
            setQuantity(value);
          }
      
          setErrorMessage("");
        }
      
        if (name === "remarks") {
          setDescription(value);
        }
      };
      
    // const handleDelete = async () => {
    //     if (!quantity || parseInt(quantity, 10) < 1) {
    //         setErrorMessage("Enter a valid quantity greater than 0.");
    //         inputRef.current.focus();
    //         return;
    //     }
    //     try {
    //         if (!checkNetwork()) return;
    //         setErrorMessage("");
    //         setDeleteBtnLoading(true);
    //         const data = {
    //             // stocklid: isSelectedItem._id,
    //             productid: isSelectedItem.productid,
    //             stockid: isSelectedItem.stockid,
    //             quantity: parseInt(quantity),
    //             remarks: description,
    //         };
    //         const response = await AxiosInstance.delete(`module/stock/trash/${isSelectedItem.stockLinkId}`, {data});
    //         const updatedStockLeft = response.data.results?.quantity ? isSelectedItem.stockLeft - quantity : isSelectedItem.stockLeft;
            
    //         const results=response.data.results;
            
    //         onStockUpdate(isSelectedItem.productid, quantity)
            
    //         setStockData((prevData) => {
    //             const exists = prevData.some((item) => item.stockLinkId === results.stockLinkId);
    //             if (exists) {
    //               return prevData.map((item) =>
    //                 item.stockLinkId === results.stockLinkId
    //                   ? { ...item, stockLeft: updatedStockLeft }
    //                   : item
    //               );
    //             } else {
    //               return [...prevData, { ...results, stockLeft: quantity }];
    //             }
    //           });

    //         closeCurrentModal();
    //         showAlert("success", Messages.SUCCESS.STOCK_DELETED);
    //     } catch (error) {
    //         handleError(error, showAlert);
    //     } finally {
    //         setDeleteBtnLoading(false);
    //     }
    // };


    const handleStockTrash = async (updatedData, quantity, remarks,selectedUnit) => {
        setDeleteBtnLoading(true);
        console.log(updatedData)
        try {
          if (!checkNetwork()) return;
          const data = {
            productid: updatedData.productid,
            stockid: updatedData.stockid,
            // stocklid: updatedData.stocklid,
            ...(remarks && { remarks }),
            // quantity: Number(updatedData?.isSecondaryUnit?primaryQuanity(quantity,updatedData?.unitConfig):quantity),
            quantity: Number(
              updatedData?.isSecondaryUnit &&
              selectedUnit === updatedData?.unitConfig?.secondaryUnitCode
                ? primaryQuanity(quantity, updatedData?.unitConfig)
                : quantity
            ),
          };
          const response = await AxiosInstance.delete(
            `module/stock/trash/${updatedData.stockLinkId}`,
            { data },
          );
          var index = updatedData.cIndex;
          updatedData = response.data.results;
    
          setStockData((prevStock) =>
            prevStock.map((item) =>
              item.stockLinkId === updatedData.stockLinkId
                ? {
                    ...item,
                    stockLeft: Number(
                      (item.stockLeft - updatedData.quantity).toFixed(3),
                    ),
                  }
                : item,
            ),
          );
    
          // setFilteredData((prevFiltered) => {
          //   if (prevFiltered[index]?._id === updatedData._id) {
          //     const updatedFiltered = [...prevFiltered];
          //     updatedFiltered[index] = { ...prevFiltered[index], ...updatedData };
          //     return updatedFiltered;
          //   }
          //   return prevFiltered.map((item) =>
          //     item._id === updatedData._id ? { ...item, ...updatedData } : item
          //   );
          // });
          showAlert("success", Messages.SUCCESS.STOCK_TRASHED);
          closeCurrentModal();
        } catch (error) {
          handleError(error, showAlert);
          return false;
        } finally {
          setDeleteBtnLoading(false);
        }
      };

    const handleEnterFocus = (e, nextRef) => {
        if (e.key === "Enter") {
          e.preventDefault();
          const isQuantityField = e.target === inputRef.current;
          if (isQuantityField) {
            const trimmedData = String(quantity || "").trim();
            const parsedValue = parseFloat(trimmedData);
    
            if (!trimmedData || isNaN(parsedValue) || parsedValue <= 0) {
              setErrorMessage((prev) => ({
                ...prev,
                quanity: "Enter a valid quantity greater than 0.",
              }));
              return;
            }
    
            setErrorMessage((prev) => ({
              ...prev,
              quanity: "",
            }));
          }
    
          nextRef?.current?.focus();
        }
      };
    
    //   const handlePaymodeKeyDown = (e) => {
    //     if (e.key === "Enter") {
    //       e.preventDefault();
    //       const trimmedValue = String(e.target.value || "").trim();
    //       if (!trimmedValue) {
    //         setErrorMessage((prev) => ({
    //           ...prev,
    //           remarks: "This field should not be empty.",
    //         }));
    //         return;
    //       }
    
    //       setErrorMessage((prev) => ({
    //         ...prev,
    //         remarks: "",
    //       }));
    //       handleDelete(e);
    //     }
    //   };

  useEffect(() => {
    if (!isSelectedItem?.stockLeft) return;

    if (selectedUnitType === "secondary") {
      const secondaryQty = toSecondaryQuantity(
        isSelectedItem.stockLeft,
        isSelectedItem.unitConfig || {},
      );

      setQuantity(
        typeof secondaryQty === "object"
          ? secondaryQty.secondaryQty
          : secondaryQty,
      );
    } else {
      setQuantity(isSelectedItem.stockLeft || "");
    }

    setErrorMessage("");
    setDescription("");

    if (remarksRef.current) {
      remarksRef.current.focus();
      remarksRef.current.select();
    }
  }, [isSelectedItem.stockLeft, selectedUnitType]);

  console.log("isSelectedItem", isSelectedItem);

  return (
    <div>
      <div className="modal-backdrop show"></div>

            {!isDeleteModalOpen && (
                <div className="modal show" id="CustomerModal" tabIndex="-1" aria-labelledby="stockAvailabilityModalLabel" aria-modal="true" role="dialog" style={{ display: "block" }}>
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="stockAvailabilityModalLabel">Stock Availability</h6>
                                <button type="button" onClick={onClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body px-0">
                                <div className="d-block px-2">
                                    <h6 className="text-center py-2">
                                        <span className="badge rounded-pill bg-label-navy">
                                            {isStockData[0]?.code} </span>
                                        &nbsp;- {isStockData[0]?.title}
                                    </h6>
                                </div>
                                
                                <Table
                                data={isStockData}
                                onRowClick={(item,index)=>openDeleteModal(item,index)}
                                columns={[
                                    {
                                        label:"MRP",render:(item)=>(
                                            <span className="badge bg-label-fall rounded-pill text-right">
                                            {formatCurrencyFun(item?.mrp)}
                                        </span>
                                        )
                                    },{
                                        label:"Sale Price",render:(item)=>(
                                            <span className="badge bg-label-food rounded-pill text-right">
                                                            {formatCurrencyFun(item?.saleprice)}
                                                        </span>
                                        )
                                    },{
                                        label:"Tax(%)",render:(item)=>(
                                            <span className="badge bg-label-peace">{item?.taxpercentage ? `${item?.taxpercentage}%` : "0%"}</span>
                                        )
                                    },{
                                        label:"Date",render:(item)=>(
                                            <span>
                                                <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                                                            MFD: {item?.manufacturedate ? DateConverter.ISOToDisplayFormat(DateConverter.convertToTimeZone(item?.manufacturedate,"Asia/kolkata")).date : ""}
                                                        </small>
                                                        <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                                                            EXP: {item?.expiredate ? DateConverter.ISOToDisplayFormat(DateConverter.convertToTimeZone(item?.expiredate,"Asia/kolkata")).date : ""}
                                                        </small>
                                            </span>
                                        )
                                    },{
                                        label:"Stock",thClass:"w-20" ,render:(item,index)=>(
                                          <div className="no-print position-relative">
                                          <div className="d-flex justify-content-center align-items-center">
                                        <span className="stock-status-badge">
                                            <span className="badge bg-label-space mx-1">
                                            {Number(item?.isSecondaryUnit
                                ? secondaryQuanity(item.stockLeft,item?.unitConfig)
                                : item?.stockLeft)}{" "}<span className="font-11 ms-1">
                                {
                                (() => {
                                  const unitCode = item?.isSecondaryUnit
                                    ? item?.unitConfig?.secondaryUnitCode
                                    : item?.unitConfig?.primaryUnitCode;

                                  // return unitCode !== "unit" ? unitCode : "";
                                  return unitCode;
                                })()
                              }</span>
                                            {/* {item.createdby} */}
                                        </span>
                                        {/* <span className="badge bg-label-white p-0">
                                            { item.isInitial ? (
                                                ""
                                            ) : (
                                                <i class="bx bx-arrow-from-top"></i>
                                            )}
                                        </span> */}
                                         / <span className="badge bg-label-spring">{Number(item?.isSecondaryUnit
                                            ? secondaryQuanity(item.stockIn,item?.unitConfig)
                                            : item?.stockIn)}{""}
                                            <span className="font-11 ms-1">
                                            {
                                            (() => {
                                            const unitCode = item?.isSecondaryUnit
                                                ? item?.unitConfig?.secondaryUnitCode
                                                : item?.unitConfig?.primaryUnitCode;

                                            // return unitCode !== "unit" ? unitCode : "";
                                            return unitCode ;
                                            })()
                                        }</span></span>
                                         </span>
                                         <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                                                            <button
                                                                type="button"
                                                                className="btn-label-danger shadow-none"
                                                               onClick={(e) => {
                                                                 e.stopPropagation();
                                                                 openDeleteModal(item, index)}}
                                                            >
                                                                <TrashIcon/>
                                                            </button>
                                                        </div>
                                         </div>
                                         </div>
                                        )
                                    },
                                    // {
                                    //     label:"Actions",render:(item,index)=>(
                                    //         <div className="order-actions opacity-0 opacity-md-100">
                                    //                         <button
                                    //                             type="button"
                                    //                             className="btn-label-danger shadow-none"
                                    //                            onClick={(e) => {
                                    //                              e.stopPropagation();
                                    //                              openDeleteModal(item, index)}}
                                    //                         >
                                    //                             <i className="bx bx-trash"></i>
                                    //                         </button>
                                    //                     </div>
                                    //     )
                                    // }
                                ]}/>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* {isDeleteModalOpen && (
                <div className="modal show" tabIndex="-1" aria-labelledby="trashStockModalLabel" aria-modal="true" role="dialog" style={{ display: "block" }}>
                    <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="trashStockModalLabel">Trash Stock</h6>
                                <button type="button" onClick={closeCurrentModal} className="btn-close" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <h6 className="text-center">{isSelectedItem.title}</h6>
                                <h6 className="text-center">
                                    <small>Available Stock - </small>
                                    <span className="badge bg-label-kids">{isSelectedItem.stockLeft}</span>
                                </h6>
                                <div className="card w-100 radius-10 mb-0">
                                    <div className="card-body">
                                        <form className="row g-3">
                                            <div className="col-md-12">
                                                <label className="form-label">
                                                    Quantity <small className="text-danger">*</small>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="inputValue"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    ref={inputRef}
                                                    value={quantity}
                                                    onChange={handleInputChange}
                                                    onFocus={(e) => e.target.select()}
                                                    onKeyDown={(e) => handleEnterFocus(e, remarksRef)}
                                                    autoFocus
                                                />
                                                {errorMessage.quanity && (
                                                        <small className="text-danger">
                                                        {errorMessage.quanity}
                                                        </small>
                                                    )}
                                            </div>
                                            <div className="col-md-12">
                                                <label htmlFor="description" className="form-label">Remarks <small className="text-danger">*</small></label>
                                                <textarea
                                                    type="text"
                                                    autoComplete="off"
                                                    maxLength="5000"
                                                    className="form-control"
                                                    value={description}
                                                    name="remarks"
                                                    ref={remarksRef}
                                                    onChange={handleInputChange}
                                                    onFocus={(e) => e.target.select()}
                                                    onKeyDown={(e) => handlePaymodeKeyDown(e)}
                                                ></textarea>
                                                {errorMessage.remarks && (
                                                        <small className="text-danger">
                                                        {errorMessage.remarks}
                                                        </small>
                                                    )}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-block">
                                <button
                                    onClick={closeCurrentModal}
                                    type="button"
                                    className="btn btn-outline-secondary text-left"
                                >
                                    <i className="lni lni-close fs-15"></i> Cancel
                                </button>
                                {isDeleteBtnLoading ? (
                                    <button className="btn btn-danger pb-0 text-right" disabled>
                                        <CircularProgress size={22} className="text-white" />
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="btn btn-danger text-right"
                                        onClick={handleDelete}
                                    >
                                        <i className="bx bx-trash"></i> Trash
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
            {isDeleteModalOpen && (
              <StockOut
              data={isSelectedItem}
              onClose={closeCurrentModal}
              onEdit={handleStockTrash}
              isBtnLoading={isDeleteBtnLoading}
            />  
            )}
        </div>
    );
};

export default ViewAvailable;
